import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EFolderGridItemDto } from 'src/app/models/dtos/e-folder-grid-item-dto';
import { FileService } from 'src/app/shared/services/file-service';

export interface EDocumentDetailsComponentData {
  dto: EFolderGridItemDto;
}

@Component({
  selector: 'app-e-document-details',
  templateUrl: './e-document-details.component.html',
  styleUrls: ['./e-document-details.component.scss'],
  standalone: false
})
export class EDocumentDetailsComponent implements OnInit {

  dto: EFolderGridItemDto;

  displayedColumns: string[] = [
    'key',
    'value',
  ];

  constructor(
    private fileService: FileService,
    @Inject(MAT_DIALOG_DATA) private data: EDocumentDetailsComponentData,
  ) {
    this.dto = data.dto;
  }

  ngOnInit(): void {
  }

  onPreviewFileBtnClick() {
    const endpoint = `e-documentations/files`;
    this.fileService.showFile(this.dto.OriginalFileName, this.dto.Id, endpoint);
  }
}
